import { RouterModule, Routes } from '@angular/router';

import { NbAuthComponent } from './components/auth.component';
import { NbLoginComponent } from './components/login/login.component';
import { RestorePasswordComponent } from './components/change-password/change-password.component';
import { NgModule } from '@angular/core';
import { SetPasswordComponent } from './components/set-password/set-password.component';

const routes: Routes = [
  {
    path: '',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        component: NbLoginComponent,
      },
      {
        path: 'login',
        component: NbLoginComponent,
      },
      {
        path: 'restore-password',
        component: RestorePasswordComponent,
      },
      {
        path: 'activation',
        component: SetPasswordComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
